import api from '@/api';

const { $messages }  = api

export const { $studentmessage }  = $messages